"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castiglione-d-orcia": {
    "6dd58783": [{
      "hkey": "132be280",
      "slug": "monte-amiata-scalo",
      "name": "Monte Amiata Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "montamiata": [{
      "hkey": "132be280",
      "slug": "monte-amiata-scalo",
      "name": "Monte Amiata Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "033f7760": [{
      "hkey": "ed921ab4",
      "slug": "castiglione-d-orcia",
      "name": "Castiglione d'Orcia",
      "primary": true,
      "skipSearch": false
    }],
    "ripa-d-orcia": [{
      "hkey": "ed921ab4",
      "slug": "castiglione-d-orcia",
      "name": "Castiglione d'Orcia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;